import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jobService } from '../../services/job.service';

const JobAccessControl = ({ jobId, children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const checkJobAccess = async () => {
      try {
        const response = await jobService.getJob(jobId);
        setLoading(false);
      } catch (error) {
        console.error('Job access error:', error);
        if (error.response?.status === 403) {
          navigate('/jobs', { 
            replace: true,
            state: { error: 'You do not have permission to access this job' }
          });
        } else {
          setError(error.message || 'Failed to load job details');
          setLoading(false);
        }
      }
    };

    if (jobId) {
      checkJobAccess();
    }
  }, [jobId, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return children;
};

export default JobAccessControl; 